import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import service from "../../services";
import Loader from "../../component/loader";
import logo from "../../assets/images/SFF_logo_2024.svg";
import ErrorPopUp from "../../component/errorPopUp";
import { ActCreators } from "../../redux/bindActionCretor";
import FilmDetail from "./components/film-detail";
import Modal from "./components/modal";
import Message from "./components/message";
import Question from "./components/question";

import Cookies from "universal-cookie";

let sub;
const cookies = new Cookies();
const PAGINATION_LIMIT = 50;

class ScreeningPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorPopup: false,
      chatModal: false,
      qaModal: false,
      filmData: {},
      screenerUserCount: "",
      message: "",
      messagePagination: {},
      questionPagination: {},
      questions: [],
      messages: [],
      senderName: "",
      chatStatus: "",
      questionStatus: "",
      messageBottom: true,
      questionBottom: true,
      sort: "latest", //latest, like
      sortFlag:"latest"
    };
    this.apiserve = new service();

  }

  componentWillUnmount = () => {
    this.logout();
    if (sub) sub.unsubscribe();
  };

  componentDidMount = () => {
    if (this.props.scannerLoginData.filmId && this.props.scannerLoginData.channelId && this.props.scannerLoginData.filmType) {
      const senderName = cookies.get(this.props.scannerLoginData.filmId);
      if (senderName) this.setState({ senderName });
      this.setState({ loaderFlag: true });
      this.mainEvent();
      this.responseHandler();
    } else this.logout();
  };
  responseHandler = () => {
    var self = this;
    sub = this.apiserve.getevent().subscribe((response) => {
      if (!response.error) {
        switch (response.event) {
          case "adminPrivateScreening|screenerScreenDetail": {
            this.setState({ filmData: response.data, loaderFlag: false });
            break;
          }
          case "admin|screenerUserCount": {
            this.setState({ screenerUserCount: response.data.count });
            break;
          }

          case "admin|screenerGetMessage": {
            const messages = JSON.parse(JSON.stringify(self.state.messages));
            const localState = {};
            response.data.docs =response.data.docs.reverse()
            if (response.data.page === 1) localState.messages = response.data.docs;
            else localState.messages = [...response.data.docs, ...messages];

            localState.messagePagination = response.data;
            this.setState({ ...localState }, () => {
              const messages = JSON.parse(JSON.stringify(self.state.messages));
              if (response.data.page) {
                if (response.data.page === 1) {
                  const objDiv = document.getElementById("live-chat-messages");
                  objDiv.scrollTop = objDiv.scrollHeight;
                } else {
                  const i = messages.length - response.data.pagingCounter;
                  if (i && messages[i]) {
                    const messageDiv = document.getElementById(messages[i]._id);
                    if (messageDiv) messageDiv.scrollIntoView({ block: "nearest" });
                  }
                }
              }
            });
            break;
          }
          case "userScreening|publishMessage":
          case "admin|screenerPublishMessage": {
            const messages = JSON.parse(JSON.stringify(self.state.messages));
            const localState = {};
            if (response.data.channelId === this.props.scannerLoginData.channelId) {
              messages.push(response.data);
              localState.messages = messages;
            }
            this.setState({ ...localState }, () => {
              const messages = JSON.parse(JSON.stringify(self.state.messages));
              if (response.data._id.length !== 0) {
                const i = messages.findIndex(e => e._id === response.data._id);
                const objDiv = document.getElementById("live-chat-messages");
                if (i > -1 && messages[i].senderName === self.state.senderName) objDiv.scrollTop = objDiv.scrollHeight;
                else {
                  if (self.state.messageBottom) objDiv.scrollTop = objDiv.scrollHeight;
                }
              }
            });
            break;
          }
          case "admin|screenerDeleteMessage": {
            const messages = JSON.parse(JSON.stringify(self.state.messages));
            const localState = {};
            localState.messages = messages.filter(e => e._id !== response.data.messageId);
            this.setState({ ...localState,loaderFlag:false});
            break;
          }

          case "admin|screenerGetQuestion": {
            const questions = JSON.parse(JSON.stringify(self.state.questions));
            const localState = {};

            if (response.data.page === 1) localState.questions = response.data.docs;
            else localState.questions = [...response.data.docs, ...questions];

            localState.questionPagination = response.data;
            this.setState({ ...localState }, () => {
              const questions = JSON.parse(JSON.stringify(self.state.questions));
              if (response.data.page) {
                if (response.data.page === 1) {
                  const objDiv = document.getElementById("live-questions");
                  objDiv.scrollTop = objDiv.scrollHeight;
                } else {
                  const i = questions.length - response.data.pagingCounter;
                  if (i && questions[i]) {
                    const questionDiv = document.getElementById(questions[i]._id);
                    if (questionDiv) questionDiv.scrollIntoView({ block: "nearest" });
                  }
                }
              }
            });
            break;
          }
          case "userScreening|publishQuestion": {
            const questions = JSON.parse(JSON.stringify(self.state.questions));
            const localState = {};
            if (response.data.channelId === this.props.scannerLoginData.channelId) {
              questions.push(response.data);
              localState.questions = questions;
            }
            this.setState({ ...localState }, () => {
              if (response.data._id.length !== 0) {
                const objDiv = document.getElementById("live-questions");
                if (self.state.questionBottom) objDiv.scrollTop = objDiv.scrollHeight;
              }
            });
            break;
          }
          case "admin|screenerDeleteQuestion": {
            const questions = JSON.parse(JSON.stringify(self.state.questions));
            const localState = {};
            localState.questions = questions.filter(e => e._id !== response.data.questionId);
            this.setState({ ...localState,loaderFlag:false });
            break;
          }
          case "admin|screenerCheckedQuestion": {
            const questions = JSON.parse(JSON.stringify(self.state.questions));
            const localState = {};
            localState.questions = questions.map(e => {
              if (e._id === response.data.questionId) e.isChecked = response.data.flag;
              return e;
            });
            this.setState({ ...localState });
            break;
          }
          case "userScreening|updateQuestionLike": {
            const questions = JSON.parse(JSON.stringify(self.state.questions));
            const localState = {};
            localState.questions = questions.map(e => {
              if (e._id === response.data.questionId) e.totalLikes = response.data.totalLikes;
              return e;
            });
            this.setState({ ...localState });
            break;
          }
          case "admin|screenerChannelStatus": {
            this.setState({
              chatStatus: response.data.chatStatus,
              questionStatus: response.data.questionStatus
            });
            break;
          }
          case "admin|screenerChangeChannelStatus": {
            if(response.data.channelId === this.props.scannerLoginData.channelId){
              this.setState({
                chatStatus: response.data.chatStatus,
                questionStatus: response.data.questionStatus
              });
            }
            break;
          }
          default:
            break;
        }
      } else this.setState({ errorPopup: true, errorMsg: response.data.error ? response.data.error : response.data });

    });
  };

  getMessages = () => {
    const { scannerLoginData: loginData } = this.props;
    const { messagePagination: _MP } = this.state;
    const data = {
      channelId: loginData.channelId,
      limit: PAGINATION_LIMIT,
      page: _MP.nextPage ? _MP.nextPage : 1,
      screeningType: 'PrivateScreeningPartnerScreen'
    };

    this.apiserve.sendevent("admin|screenerGetMessage", data);
  };
  getQuestions = () => {
    const { questionPagination: _QP } = this.state;
    const { scannerLoginData: loginData } = this.props;
    const sortByQuestion = {
      channelId: loginData.channelId,
      sortBy: this.state.sort,
      limit: 100000,
      page: _QP.nextPage ? _QP.nextPage : 1,
      screeningType: 'PrivateScreeningPartnerScreen'
    };
    this.apiserve.sendevent("admin|screenerGetQuestion", sortByQuestion);
  };

  errorMsgPopup = () => this.setState({ errorPopup: false });
  mainEvent = () => {
    const { scannerLoginData } = this.props;
      const data = {
        channelId: scannerLoginData.channelId,
      };
    this.apiserve.sendevent("adminPrivateScreening|screenerScreenDetail", data);
    this.getMessages();
    this.getQuestions();
    this.screenerUserCount();
    this.screenerChannelStatus();
    this.setState({ loaderFlag: true });
  };
  screenerUserCount = () => {
    const { scannerLoginData } = this.props;
    const screenerUser = { channelId: scannerLoginData.channelId };
    this.apiserve.sendevent("admin|screenerUserCount", screenerUser);
  };
  screenerChannelStatus = () => {
    const { scannerLoginData } = this.props;
    const screenerChannelStatus = { channelId: scannerLoginData.channelId,screeningType: 'PrivateScreeningPartnerScreen' };
    this.apiserve.sendevent("admin|screenerChannelStatus", screenerChannelStatus);
  };
  changeSort = sort => {
    this.setState({ sort,sortFlag:sort, questionPagination: {} }, () => this.getQuestions());
  };
  refresh = () => {
    this.setState({});
    this.forceUpdate();
    this.mainEvent();
  };
  sendMessage = (e) => {
    e.preventDefault();
    if (e.keyCode && e.keyCode !== 13) return;
    const m = this.state.message.trim();
    const { scannerLoginData } = this.props;
    if (m.length !== 0) {
      const data = {
        message: m,
        channelId: scannerLoginData.channelId,
        senderName: this.state.senderName,
        screeningType: 'PrivateScreeningPartnerScreen'
      };
      this.apiserve.sendevent("admin|screenerPublishMessage", data);
      this.setState({
        message: ""
      });
    }
  };

  clearMsg = () => this.setState({message:''});
  ChatOff = () => this.setState({ chatModal: true });
  QaOff = () => this.setState({ qaModal: true });
  closeModal = type => {
    if (type === "chat") this.setState({ chatModal: false });
    else this.setState({ qaModal: false });
  };
  saveName = () => {
    cookies.set(this.props.scannerLoginData.filmId, this.state.senderName, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/", secure: true });
  };
  logout = () => {
    const search = this.props.location.search;
    cookies.remove(this.props.scannerLoginData.filmId, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
    this.props.ScannerLoginData({});
    this.props.history.push(`signin${search}`);
  };

  deleteMessage = id => {
    const data = { messageId: id };
    this.apiserve.sendevent("admin|screenerDeleteMessage", data);
    this.setState({loaderFlag:true})
  };

  deleteQuestion = id => {
    const data = { questionId: id };
    this.apiserve.sendevent("admin|screenerDeleteQuestion", data);
    this.setState({
      loaderFlag:true
    })
  };
  checkQuestion = (e, id) => {
    const data = { questionId: id, flag: e.target.checked };
    this.apiserve.sendevent("admin|screenerCheckedQuestion", data);
  };

  messageScroll = e => {
    const { messagePagination: _MP } = this.state;
    if (e.target.scrollTop === 0) {
      if (_MP.hasNextPage) this.getMessages();
    }
    this.setState({ messageBottom: e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 50 });
  };
  questionScroll = e => {
    const { questionPagination: _QP } = this.state;
    if (e.target.scrollTop === 0) {
      if (_QP.hasNextPage) this.getQuestions();
    }
    this.setState({ questionBottom: e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 50 });
  };


  render() {

    const {
      filmData,
      screenerUserCount,
      questions,
      messages,
      chatStatus,
      questionStatus,
      chatModal,
      qaModal,
      loaderFlag,
      errorPopup,
      errorMsg,
      message,
      senderName
    } = this.state;
    return (
      <>
        <div className="container">
          <header>
            <div className="logo">
              <img src={logo} />
            </div>
            <div className="support_link">
              <a href={null} onClick={this.logout.bind(this)}>End and Exit Live Q&A</a>
            </div>
          </header>
          <div className="screening_detail_view">
            {filmData && <FilmDetail film={filmData} userCount={screenerUserCount} imageUrl={this.apiserve.imageUrl} />}
            <div className="chat_outer">
              <form>
                <div className="d_flex">
                  <div className="chat_content relative">
                    <div className="chat_header d_flex d_flex_justify_spacebt d_flex_align_center">
                      <div className="d_flex d_flex_align_center">
                        <h2 className="mr_15">CHAT</h2>
                        <span className="turn_off_btn pointer ml_10" onClick={this.ChatOff}>{chatStatus === 2 ? "TURN ON" : "TURN OFF"}</span>
                      </div>
                      <div className="chat_search">
                        <input type="text" placeholder="Moderator Name" value={senderName} name="senderName"
                               onChange={(e) => this.setState({ senderName: e.target.value })} onBlur={this.saveName.bind(this)} />
                      </div>
                    </div>
                    <div className="chat_list_wrap" id="live-chat-messages" onScroll={this.messageScroll}>
                      {messages.map((data, i) => {
                        return <Message
                        key={data._id}
                        id={data._id}
                        sender={data.senderName}
                        message={data.message}
                        isModerator={data.isModerator}
                        image={data.image}
                        loaderFlag={this.state.loaderFlag}
                        imageUrl={this.apiserve.imageUrl}
                        delete={() => this.deleteMessage(data._id)}
                      />;
                      })}
                    </div>
                    <div className="chat_message">
                      <textarea placeholder="Your text here" name="message" value={message}
                                onChange={(e) => this.setState({ message: e.target.value })}
                                onKeyUp={(e) => this.sendMessage(e)}  maxLength={280}/>
                      <div className="field_row text_right">
                        <button type='button' onClick={()=>this.clearMsg()}>Clear</button>
                        <button className="active" onClick={(e) => this.sendMessage(e)}>Submit</button>
                      </div>
                    </div>
                    {chatModal && <Modal type="chat" close={() => this.closeModal("chat")} chat={chatStatus} question={questionStatus} />}
                  </div>
                  <div className="chat_content qa_content relative">
                    <div className="chat_header qa_header">
                      <div className="d_flex d_flex_align_center">
                        <h2 className="mr_15">Live Q&A</h2>
                        <span className="turn_off_btn pointer ml_10" onClick={this.QaOff}>{questionStatus === 2 ? "TURN ON" : "TURN OFF"}</span>
                      </div>
                      <div className="qa_subtitle d_flex">
                        <p className="qa_subtitle_text">Submitted Questions With Like Counts</p>
                        <div className="sort_by d_flex d_flex_align_center">
                          <p className={this.state.sortFlag === 'latest' ? 'active' : ''} onClick={() => this.changeSort("latest")}>Sort by latest</p>
                          <p className={this.state.sortFlag === 'latest' ? 'active' : ''} onClick={() => this.changeSort("like")}>Sort by highest likes</p>
                        </div>
                      </div>
                    </div>
                    <div className="qa_content_inner">
                      <div className="sundance_qa_list">
                        <ul id="live-questions" onScroll={this.questionScroll}>
                          {questions.map((data, i) => {
                            return <Question
                              key={data._id}
                              id={data._id}
                              totalLikes={data.totalLikes}
                              senderName={data.senderName}
                              isModerator={data.isModerator}
                              question={data.question}
                              isChecked={data.isChecked}
                              loaderFlag={this.state.loaderFlag}
                              delete={() => this.deleteQuestion(data._id)}
                              check={e => this.checkQuestion(e, data._id)}
                            />;
                          })}
                        </ul>
                      </div>
                    </div>

                    {qaModal && <Modal type="question" close={() => this.closeModal("question")} chat={chatStatus} question={questionStatus} />}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {loaderFlag && <Loader />}
        {errorPopup && <ErrorPopUp errorMsg={errorMsg} errorMsgPopup={this.errorMsgPopup} />}

      </>
    );
  }
}

const mapStateToProps = state => ({
  scannerLoginData: state.scannerLoginData,
  profileName: state.profileName
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningPage);